import { apiClient, unwrap } from './client';

import type { ApiResponse, Evidence, ReviewResult } from '@/types';

export interface ReviewQueueItem {
  submission_id: number;
  student_name: string;
  job_title?: string | null;
  job_id?: number | null;
  status: string;
  score: number | null;
  confidence: string | null;
  submitted_at: string;
}

export interface ReviewQueueResponse {
  items: ReviewQueueItem[];
  total: number;
  progress: { total: number; reviewed: number; pending: number };
}

export async function getReview(submissionId: number): Promise<ReviewResult> {
  const response = await apiClient.get<ApiResponse<ReviewResult>>(`/review/${submissionId}`);
  return unwrap(response);
}

export async function confirmReview(
  submissionId: number,
  evidences: Evidence[],
): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/review/${submissionId}/confirm`,
    { evidences },
  );
  return unwrap(response);
}

export async function modifyReview(
  submissionId: number,
  data: { score: number; evidences: Evidence[]; comment?: string },
): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/review/${submissionId}/modify`,
    data,
  );
  return unwrap(response);
}

export async function rejectReview(submissionId: number, reason: string): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/review/${submissionId}/reject`,
    { reason },
  );
  return unwrap(response);
}

export async function addComment(submissionId: number, comment: string): Promise<{ ok: boolean }> {
  const response = await apiClient.post<ApiResponse<{ ok: boolean }>>(
    `/review/${submissionId}/comment`,
    { comment },
  );
  return unwrap(response);
}

export async function getReviewQueue(
  jobId: number,
  params: { page?: number; limit?: number } = {},
): Promise<ReviewQueueResponse> {
  const response = await apiClient.get<ApiResponse<ReviewQueueResponse>>(
    `/review/queue/${jobId}`,
    { params },
  );
  return unwrap(response);
}

/** 学习通式批阅中心：跨作业的全局待批阅队列（待批阅优先） */
export async function getReviewQueueAll(
  params: { page?: number; limit?: number } = {},
): Promise<ReviewQueueResponse> {
  const response = await apiClient.get<ApiResponse<ReviewQueueResponse>>(
    '/review/queue',
    { params },
  );
  return unwrap(response);
}
